<template>
  <div>
    <h4>{{ triage.label }}</h4>
    <p>
      {{ triage.description }}
    </p>
  </div>
</template>
<script>
export default {
  props: {
    triage: {
      type: Object,
      required: true
    }
  }
}
</script>
